/**
 * BulkActionBar — contextual bar that slides in above the table when rows are selected.
 *
 * @param {{
 *   selectedCount: number,
 *   onExport: () => void,
 *   onMoveOut: () => void,
 *   onClearSelection: () => void
 * }} props
 */
const BulkActionBar = ({ selectedCount, onExport, onMoveOut, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="rp-bulk-bar">
      <div className="rp-bulk-bar__left">
        <span className="rp-bulk-bar__count">
          {selectedCount} resident{selectedCount !== 1 ? 's' : ''} selected
        </span>
        <button
          type="button"
          onClick={onClearSelection}
          className="rp-bulk-bar__deselect"
        >
          Deselect All
        </button>
      </div>

      <div className="rp-bulk-bar__right">
        <button
          type="button"
          onClick={onExport}
          className="rp-bulk-btn"
          aria-label="Export selected residents"
        >
          <svg className="rp-icon-sm" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
          Export
        </button>

        <button
          type="button"
          onClick={onMoveOut}
          className="rp-bulk-btn rp-bulk-btn--danger"
          aria-label="Move out selected residents"
        >
          <svg className="rp-icon-sm" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
          </svg>
          Move Out
        </button>
      </div>
    </div>
  );
};

export default BulkActionBar;
